import React, { useState, useEffect } from 'react';
import { useQuill } from 'react-quilljs';
import 'quill/dist/quill.snow.css'; // Import Quill styles
import Quill from 'quill';
import ImageResize from 'quill-image-resize';
import { db, storage } from '../../firebase/firebase';
import { ref as dbRef, push, set } from 'firebase/database';
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { CircularProgress } from '@mui/material';

Quill.register('modules/imageResize', ImageResize);

export default function NewPost() {
    const [content, setContent] = useState([]);
    const [postTitle, setPostTitle] = useState('');
    const [loading, setLoading] = useState(false);
    const [prevImg, setPrevImg] = useState('')
    const [prevImgFile, setPrevImgFile] = useState(null);
    const { quill, quillRef } = useQuill({
        theme: 'snow',
        modules: {
            imageResize: {},
            toolbar: [
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],  // Header dropdown
                ['bold', 'italic', 'underline', 'strike'],  // Bold, italic, underline, strike
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],  // Lists
                [{ 'script': 'sub' }, { 'script': 'super' }],  // Subscript/superscript
                [{ 'indent': '-1' }, { 'indent': '+1' }],  // Indent/outdent
                [{ 'direction': 'rtl' }],  // Text direction
                [{ 'size': ['small', false, 'large', 'huge'] }],  // Custom dropdown
                [{ 'color': [] }, { 'background': [] }],  // Dropdown with defaults from theme
                [{ 'font': [] }],
                [{ 'align': [] }],
                ['clean'],  // Remove formatting button
                ['link', 'image'],
            ],
        }
    });

    useEffect(() => {
        if (quill) {
            quill.getModule('toolbar').addHandler('image', imageHandler);
            quill.getModule('toolbar').addHandler('video', VideoHandler);
        }
    }, [quill]);

    const imageHandler = () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.onchange = async () => {
            const file = input.files[0];
            if (file) {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    const range = quill.getSelection(true);
                    quill.insertEmbed(range.index, 'image', e.target.result);
                    setContent(prevContent => [...prevContent, { file, index: range.index }]);
                };
            }
        };
        input.click();
    };

    const VideoHandler = () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'video/*');
        input.onchange = async () => {
            const file = input.files[0];
            if (file) {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    const range = quill.getSelection(true);
                    quill.insertEmbed(range.index, 'video', e.target.result);
                    setContent(prevContent => [...prevContent, { file, index: range.index }]);
                };
            }
        };
        input.click();
    };

    const handleSubmit = async () => {
        if (postTitle && prevImgFile) {
            setLoading(true)

            let previewImageUrl = '';
            if (prevImgFile) { // Assuming you store the File object in state when image is selected
                const previewPath = `images/ar/${Date.now()}_${prevImgFile.name}`;
                const previewRef = storageRef(storage, previewPath);
                const previewSnapshot = await uploadBytes(previewRef, prevImgFile);
                previewImageUrl = await getDownloadURL(previewSnapshot.ref);
            }

            let contentHtml = quill.root.innerHTML;
            const promises = content.map(async (data) => {
                const storagePath = `images/ar/${Date.now()}_${data.file.name}`;
                const imgRef = storageRef(storage, storagePath);
                const snapshot = await uploadBytes(imgRef, data.file);
                const url = await getDownloadURL(snapshot.ref);
                contentHtml = contentHtml.replace(`src="${data.file.name}"`, `src="${url}"`);
                return url;
            });

            await Promise.all(promises);

            const postRef = dbRef(db, 'posts/ar');
            const newPostRef = push(postRef);
            await set(newPostRef, {
                postTitle: postTitle,
                imgPreview: previewImageUrl,
                content: contentHtml,
                timestamp: Date.now(),
            }).then(() => {
                setContent([]);
                setLoading(false)
                alert('Post added successfully!');
            }).catch(error => {
                setLoading(false)
                console.error('Error adding post: ', error);
            });
        } else {
            alert('Post title and preview image are empty.')
        }
    };

    const handleImageChange = (event) => {
        const file = event.target.files[0]; // Get the file from the event
        if (file && file.type.startsWith('image')) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPrevImg(reader.result); // Set the read file URL to the state
                setPrevImgFile(file);
            };
            reader.readAsDataURL(file); // Read the file as a Data URL
        } else {
            setPrevImg(''); // Reset the preview if the file is not an image
            setPrevImgFile(null);
        }
    };

    return (
        <div>
            {loading && <div className='bkdrop'><CircularProgress sx={{ color: '#fff' }} /></div>}
            <div dir='rtl'>
            <button className='submit-post-button' onClick={handleSubmit} style={{
                display: 'inline-block',
                backgroundColor: '#0086a1',
                color: '#fff',
                padding: '5px 20px',
                fontSize: '13pt',
                border: 'none',
                marginBottom: '10px',
                marginLeft: '30px',
                fontFamily: 'Arial',
                borderRadius: '10px',
                fontWeight: 'bold',
                boxShadow: '0px 0px 5px .5px gray',
            }}>حفظ المنشور</button>
            <input type="text" placeholder='عنوان المنشور' onChange={(e) => { setPostTitle(e.target.value) }} style={{
                display: 'inline-block',
                fontSize: '13pt',
                padding: '5px 10px',
                outline: 'none',
                border: '2px solid #0086a1',
                borderRadius: '5px',
                width: '400px'
            }} />
            <input onChange={(e) => handleImageChange(e)} type="file" id='chooseimg' style={{ display: 'none' }} accept='images/*' />
            <label htmlFor="chooseimg" style={{ display: 'inline-block', fontSize: '13pt', fontFamily: 'Arial', backgroundColor: '#0086a1', color: 'white', padding: '5px 20px', cursor: 'pointer', marginRight: '100px', borderRadius: '5px' }}>اختر صورة</label>
            <img src={prevImg} alt="" style={{
                display: 'inline-block',
                height: '65px',
                marginRight: '20px',
                position: 'fixed',
                top: '3px'
            }} />
            </div>
            <div className='custom-quill-ar' style={{
                minHeight: 'calc(100vh - 250px)'
            }} ref={quillRef} />
        </div>
    );
}